import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)
const locale = 'en'
const messages = {
    en: {
        title: "hello"
    },
    vi: {
        title: "xin chao"
    }
}
const i18n = new VueI18n({
    locale,
    messages
})
export default i18n